var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],ref:"circlewrapper",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"chart",style:(`
      --percentageRotate: ${_vm.value > 100 ? 100 : _vm.value};
      --borderRadius: ${_vm.width}px;
      --borderWidth: ${_vm.borderWidth}px;
      height: ${_vm.height}px;
      width: ${_vm.width}px;
    `)},[_c('div',{class:_vm.colorclass}),_c('span',{staticStyle:{"display":"block","text-align":"center"}},[_c('span',{staticClass:"titlecolor--text",style:(`font-size: ${_vm.valueSize}`)},[_vm._v(" "+_vm._s(_vm.value)+_vm._s(_vm.valueSuffix)+" ")]),_c('span',{staticClass:"subtitlecolor--text text-uppercase d-block",style:(`font-Size: ${_vm.titleSize};`)},[_vm._v(" "+_vm._s(_vm.title)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }